// extracted by mini-css-extract-plugin
export default {"staticContent":"AgBqbk","frame":"whlBAM"};